import { AdaptiveDesignSystem, composeFlipper, flipperAestheticStyles, flipperStyleModules, flipperTemplateStyles } from '@adaptive-web/adaptive-web-components';

import chevronRight from '/icons/chevron-right.svg?raw';
import chevronLeft from '/icons/chevron-left.svg?raw';
import { css } from '@microsoft/fast-element';

export const customFlipperDefinition = composeFlipper(AdaptiveDesignSystem, {
	statics: {
		'flipper-next': chevronRight,
		'flipper-previous': chevronLeft
	},
	styleModules: flipperStyleModules,
	styles: [
		flipperTemplateStyles,
		flipperAestheticStyles,
		css`
			:host([direction="previous"]) .previous {
				margin-inline-end: 3px;
			}

			:host([direction="next"]) .next {
				margin-inline-start: 2px;
			}
		`
	]
});